/* eslint-disable */
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import themes from 'themes';
import SalespersonLayout from 'layout/SalespersonLayout';
import SalespersonDashboard from 'views/salesperson/Dashboard';
import ProtectedSalespersonRoute from 'routes/ProtectedSalespersonRoute';

const SalespersonPortal = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <Routes>
                    <Route
                        path="/"
                        element={
                            <ProtectedSalespersonRoute>
                                <SalespersonLayout />
                            </ProtectedSalespersonRoute>
                        }
                    >
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="dashboard" element={<SalespersonDashboard />} />
                        <Route path="projects" element={<SalespersonDashboard />} />
                    </Route>
                </Routes>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default SalespersonPortal;
